import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

// css
import './Breadcrumb.scss';

const Breadcrumb = ({links}) => {
	const disableNavLink = (e) => {
		e.preventDefault();
	}
	return (
	<div className="Breadcrumb">
		{links && links.length > 0 && links.map((link, index) => (
			<React.Fragment key={index}>
				<NavLink
					onClick={(e) => {
						disableNavLink(e);
						link.fn();
					}}
					to={link.url}
					replace
				>{link.name}</NavLink>
				{index !== (links.length - 1) && <span>&#47;</span>}
			</React.Fragment>
		))}
	</div>
);}

Breadcrumb.propTypes = {
	links: PropTypes.instanceOf(Array)
};

Breadcrumb.defaultProps = {
	links: []
};

export default Breadcrumb;


// WEBPACK FOOTER //
// ./common/Breadcrumb/Breadcrumb.js